import { createAuthClient } from 'better-auth/react'
import { magicLinkClient } from 'better-auth/client/plugins'

const BEARER_TOKEN_STORAGE_KEY = 'bearer_token'

export const authClient = createAuthClient({
  baseURL: `${import.meta.env.VITE_API_BASE}/api/auth`,
  plugins: [magicLinkClient()],
  fetchOptions: {
    auth: {
      type: 'Bearer',
      token: () => localStorage.getItem(BEARER_TOKEN_STORAGE_KEY) ?? '',
    },
    onSuccess: (ctx) => {
      const authToken = ctx.response.headers.get('set-auth-token')
      if (authToken) {
        localStorage.setItem(BEARER_TOKEN_STORAGE_KEY, authToken)
      }
    },
  },
})

export const getBearerToken = () => {
  return localStorage.getItem(BEARER_TOKEN_STORAGE_KEY)
}

export const clearBearerToken = () => {
  localStorage.removeItem(BEARER_TOKEN_STORAGE_KEY)
}

export type AuthSession = typeof authClient.$Infer.Session

